// KEEP THIS FILE IN SYNC WITH ds-variables.scss
export interface DsSizes {
  spacing: number;
  borderRadius: number;
  iconSize: number;
}

export const sizes: DsSizes = {
  spacing: 20,
  borderRadius: 2,
  iconSize: 24,
};
